import { useEffect, FunctionComponent } from 'react';
import { useSiteSettings } from '../siteSettings';

interface TituloPaginaProps {
  title: string;
  pageSlug?: string;
}

const TituloPagina: FunctionComponent<TituloPaginaProps> = ({ title, pageSlug }) => {
  const { getPageBySlug } = useSiteSettings();
  const page = pageSlug ? getPageBySlug(pageSlug) : undefined;
  useEffect(() => {
    document.title = page?.browser_title || title;
  }, [page?.browser_title, title]);

  return null;
};

export default TituloPagina;
